import { jsx as _jsx } from "react/jsx-runtime";
import MuiPagination from '@material-ui/lab/Pagination';
import MuiPaginationItem from '@material-ui/lab/PaginationItem';
import { withDefaultPropsAndStyles } from '../utils';
const PaginationItem = withDefaultPropsAndStyles('PaginationItem', MuiPaginationItem, {
    styles: {
        root: {},
        selected: {},
        focusVisible: {},
        textPrimary: {},
        textSecondary: {},
        outlinedPrimary: {},
        outlinedSecondary: {},
    },
});
export function Pagination(props) {
    return _jsx(MuiPagination, Object.assign({ style: { display: 'flex' }, renderItem: (item) => _jsx(PaginationItem, Object.assign({}, item), void 0) }, props), void 0);
}
//# sourceMappingURL=Pagination.js.map